export enum VehicleGranularity {
  Manufacturers = 'Manufacturers',
  Models = 'Models',
  Vehicles = 'Vehicles',
}
